<template>
  <div>
    <Draggable
        class="dragArea toolbox-group"
        :list="draggableComponents"
        :group="{ name: 'elements', pull: 'clone', put: false }"
        item-key="name"
        @end="emitEventToCanvas($event)"
    >
      <template #item="element">
        <div class="toolbox-group-item">
          <component :is="element.element"/>
        </div>
      </template>
    </Draggable>

  </div>
</template>

<script lang="ts" setup>
import {markRaw} from 'vue'
import Draggable from 'vuedraggable'
import ModelTextWidget from '../../../components/element/DragDropElement/components/ModelTextWidget.vue'
import RegularTextWidget from '../../../components/element/DragDropElement/components/RegularTextWidget.vue'
import OutputTextWidget from '../../../components/element/DragDropElement/components/OutputTextWidget.vue'
import InputNumberWidget from '../../../components/element/DragDropElement/components/InputNumberWidget.vue'
import CsvSelectorWidget from '../../../components/element/DragDropElement/components/CsvSelectorWidget.vue'
import ImageWidget from '../../../components/element/DragDropElement/components/ImageWidget.vue'
import ChoiceWidget from '../../../components/element/DragDropElement/components/ChoiceWidget.vue'
import ChartWidget from '@/views/components/element/ChartElement/index.vue'
import TableWidget from '@/views/components/element/TableElement/index.vue'

import {nanoid} from 'nanoid'
import ModelDataWidget from "@/views/components/element/DragDropElement/components/ModelDataWidget.vue";
import ButtonWidget from "@/views/components/element/DragDropElement/components/ButtonWidget.vue";

const draggableComponents = [markRaw(RegularTextWidget),
  markRaw(ModelDataWidget),
  markRaw(CsvSelectorWidget),
  markRaw(ImageWidget),
  markRaw(ChartWidget),
  markRaw(TableWidget),
  markRaw(ButtonWidget),
]

const reverseLookup = [
  'reg_text',
  'model_data',
  'csv_selector',
  'image',
  'chart',
  'table',
  'button'
]

const emitEventToCanvas = ((event) => {
  // debugger // eslint-disable-line no-debugger
  const { to, item } = event
  const itemIndex = item.__draggable_context.index

  const customEvent = new CustomEvent('dragFromToolbox', {
    detail: {
      target: to.id,
      component: reverseLookup[itemIndex],
      elementId: nanoid(10),
      index: event.newDraggableIndex
    }
  })
  event.stopPropagation()
  dispatchEvent(customEvent)
})

</script>

<style lang="scss" >
.dragArea.toolbox-group {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-column-gap: 12px;
}

.toolbox-group-item {
  padding: 1rem 1rem;
  background-color: #f4f4f4;
  margin: 10px 0 10px 0;
  text-align: center;
  border-radius: 10px;
  height: 120px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

}

.add-text {
  justify-content: center;
  font-size: 16px;
}

.selectButtonLabel {
  font-size: 16px;
}

.selectButtonGroup {
  display: flex;
  margin-top: 10px;
  align-items: center;
  column-gap: 10px;
}

.selectButtonLabel {
  display: inline-block;
  vertical-align: middle;
}

.display-dropdown {
  margin-top: 10px;
}

</style>
